import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs/';
import { ProductsService } from 'app/agora/components/product-data/products/products.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ProductVariantService } from 'app/agora/components/product-data/product-variants/product-variant.service';

@Component({
  selector: 'itpx-product-edit-course-info',
  templateUrl: './product-edit-course-info.component.html',
  styleUrls: ['./product-edit-course-info.component.css']
})
export class ProductEditCourseInfoComponent implements OnInit {

  private durationTypeDict: Observable<{key: string, value: string}[]> = this.productVariantService.getAccessDurationTypes().map(_ => _.data);

  @Input() form: FormGroup;
  modules = {
    toolbar: [
      { 'header': [4, false] }
    ]
  }

  constructor(
    private service: ProductsService,
    private productVariantService: ProductVariantService
  ) { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/products/edit/course-info/product-edit-course-info.component.ts